import { ActionMessages, ACTIONS } from '@root/src/types/common';
import { SpaceObjectFront } from './type';

export const spaceObjectActionMessages: ActionMessages<SpaceObjectFront> = {
  [ACTIONS.CREATE]: {
    successTitleKey: 'api.spaceObject.create.successTitle',
    successDescriptionKey: 'api.spaceObject.create.successDescription',
    formatMessage: data => ({ spaceObjectName: data.name ?? '' }),
  },
  [ACTIONS.UPDATE]: {
    successTitleKey: 'api.spaceObject.edit.successTitle',
    successDescriptionKey: 'api.spaceObject.edit.successDescription',
    formatMessage: data => ({ spaceObjectName: data.name ?? '' }),
  },
  [ACTIONS.DELETE]: {
    successTitleKey: 'api.spaceObject.delete.successTitle',
    successDescriptionKey: 'api.spaceObject.delete.successDescription',
    formatMessage: data => ({ spaceObjectName: data.name ?? '' }),
  },
};
